import { createCn } from 'cn/config'

/**
 * Class merging that knows the brand's named type steps and shadows (index.css).
 *
 * Unconfigured, a merger reads `text-ui` as a text colour, because `ui` is not a
 * size it has heard of, and drops `text-muted-foreground` to make room for it.
 * vite.config.ts aliases the bare `cn` import here, so the shadcn components
 * under components/ui merge with this same configuration.
 */
export const cn = createCn({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['micro', 'caption', 'small', 'ui', 'lede', 'title', 'subtitle', 'feature', 'display'] },
      ],
      shadow: [{ shadow: ['card-lift', 'glass', 'hero-form'] }],
    },
  },
})
